import { LanguageInput } from "../input/LanguageInput";
import { PHPResponse } from "../PHPResponse";
import { PHPAdress, PHPAdresses } from "../PHPAdress";
import { PHPRequest } from "../PHPRequest";
import { EmailInput } from "./UserSignUpRequest";


export class UserRequestDeleteRequest extends PHPRequest<PHPAdress,EmailInput,PHPResponse>
{
  static readonly ADRESS = PHPAdresses.USER_REQUEST_DELETE;

  constructor(){ super( UserRequestDeleteRequest.ADRESS ); }

}
